export function filter<T>(array: Array<T>, searchString: string) {
	return array.filter((item) => deepSearch<T>(item, searchString));
}

function traverse<T>(value: T, lowerSearch: string): boolean {
	if (typeof value === "string") {
		if (value.toLowerCase().includes(lowerSearch)) {
			return true;
		}
	} else if (typeof value === "object" && value !== null) {
		for (const prop in value) {
			if (traverse(value[prop], lowerSearch)) {
				return true;
			}
		}
	}
	return false;
}

function deepSearch<T>(obj: T, searchString: string) {
	const lowerSearch = searchString.toLowerCase();
	return traverse(obj, lowerSearch);
}
